import { MINUTES } from '@sequencehq/utils/dates'

export const NETSUITE_ITEM_ACCOUNT_DEFAULT_LABEL = 'Account default'

// Shown when an item's name can't be looked up, e.g. NetSuite is down.
export const netsuiteItemFallbackLabel = (itemId: string) =>
  `NetSuite item ${itemId}`

// Every item lookup is a live NetSuite call, and names rarely change.
export const NETSUITE_ITEM_STALE_TIME = 10 * MINUTES

/**
 * The NetSuite item a credit grant posts to. A grant can also carry a Xero
 * entry, which is its ledger account rather than an item, so that's skipped.
 */
export const findNetsuiteItemId = (
  integrationIds: Array<{ service: string; id: string }> | undefined
) =>
  integrationIds?.find(integrationId => integrationId.service === 'NetSuite')
    ?.id
